import { createRouter, createWebHistory } from 'vue-router'
import { carregarSuporteSolux } from '../utils/suporte'

const routes = [
  {
    path: '/register',
    name: 'Registrar',
    component: () => import('../views/RegisterView.vue')
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/home',
    name: 'Início',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/finalizados',
    name: 'Finalizados',
    component: () => import('../views/FinalizadosView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Widget de suporte Solux: carrega apenas nas paginas internas (area autenticada),
// nunca na tela de login/publicas. A funcao em si so injeta se houver sessao valida.
const ROTAS_AUTENTICADAS = ['/home', '/finalizados']
router.afterEach((to) => {
  if (ROTAS_AUTENTICADAS.includes(to.path)) {
    carregarSuporteSolux()
  }
})

export default router
